if (!customElements.get("variant-items")) {
   class VariantItems extends HTMLElement {
      constructor() {
         super();
         this.variantValueProps = this.querySelectorAll(".js-variant-items");

         window.initLazyScript(this, this.initLazySection.bind(this));
      }

      initLazySection() {
         if (this.variantValueProps) {
            window.addEventListener("on:variant:change", this.handleVariantChange.bind(this));

            this.setVisibleVariantValueProps(this.dataset.currentVariantId);
         }
      }

      /**
       * Sets the visible variant variantValueProps.
       * @param {string} variantId - The variant id
       */
      setVisibleVariantValueProps(variantId) {
         this.variantValueProps.forEach((variantValueProp) => {
            variantValueProp.hidden = variantValueProp.dataset.variantId.toString() !== variantId.toString();
         });
      }

      /**
       * Handles a 'change' event on the variant picker element
       * @param {object} evt - Event object
       */
      handleVariantChange(evt) {
         if (evt.detail.variant) {
            this.setVisibleVariantValueProps(evt.detail.variant.id);
         }
      }
   }

   customElements.define("variant-items", VariantItems);
}
